import type { Filters } from '@ipfabric/utils';
import { isDefined } from '@ipfabric/utils/types/isDefined';
import {
  type ApiTableColumnOverride,
  apiTableColumnOverridesMap,
} from 'components/ApiTablePage/ApiTableColumnOverridesMap';
import { apiTableNoDataBoxMap } from 'components/ApiTablePage/ApiTableNoDataBoxMap';
import { ApiTablePage } from 'components/ApiTablePage/ApiTablePage';
import { type FC, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useTableEndpoint } from 'utils/table/useTableEndpoint';
import { APPLICATION_ID_PARAM } from '../applicationDetailTabs';

const DEVICES_ENDPOINT = '/tables/inventory/applications/devices';
const DEVICES_TABLE_ID = '/inventory/applications/devices';
const DEVICES_TAB_TABLE_ID = '/inventory/applications/devices/tab';

const removeLink: ApiTableColumnOverride = (column) => ({
  ...column,
  format: { ...column.format, createLinkProps: undefined },
});

const overrides: Record<string, ApiTableColumnOverride> = {
  ...apiTableColumnOverridesMap[DEVICES_TABLE_ID],
  flowId: removeLink,
};

const TAB_COLUMN_KEYS = [
  'hostname',
  'sn',
  'snHw',
  'flowId',
  'applicationFlow',
  'srcApplicationName',
  'dstApplicationName',
];

export const ApplicationDevicesTab: FC = () => {
  const { [APPLICATION_ID_PARAM]: applicationId } = useParams();

  const endpoint = useTableEndpoint({
    apiEndpoint: DEVICES_ENDPOINT,
    alternative: (base) => ({
      id: DEVICES_TAB_TABLE_ID,
      columns: TAB_COLUMN_KEYS.map((key) =>
        base.columns.find((column) => column.key === key),
      )
        .filter(isDefined)
        .map((column) => overrides[column.key]?.(column) ?? column),
    }),
  });

  const staticFilters: Filters | undefined = useMemo(
    () =>
      applicationId
        ? {
            or: [
              { srcApplicationId: ['eq', applicationId] },
              { dstApplicationId: ['eq', applicationId] },
            ],
          }
        : undefined,
    [applicationId],
  );

  return (
    <ApiTablePage
      endpoint={endpoint}
      additionalApiTableProps={{
        enableIntentEditor: true,
        noDataBox: apiTableNoDataBoxMap[DEVICES_TABLE_ID],
        staticFilters,
      }}
    />
  );
};
